import { getBytesCount } from "@utils/data"

const validateCategoryIds = (rule, value, callback) => {
    if (value.length === 0) {
        callback(new Error('请选择类目'));
    } else {
        callback();
    }
}
const validateTitle = (rule, value, callback, context) => {
    const regx = /^\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]$/;
    if (getBytesCount(value) > 60) {
        callback(new Error('最多输入30个字（60个字符）'))
    } else if (regx.test(value)) {
        callback(new Error('不能含emoj表情'));
    } else {
        callback();
    }
}
const validateShortTitle = (rule, value, callback, context) => {
    const regx = /^\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]$/;
    if (getBytesCount(value || '') > 20) {
        callback(new Error('最多输入10个字（20个字符）'))
    } else if (regx.test(value)) {
        callback(new Error('不能含emoj表情'));
    } else {
        callback();
    }
}
const validateImageUrls = async (rule, value, callback, context) => {
    let sum = 0;
    if (value.length) {
        value.forEach(v => {
            if (v) sum++;
        })
    }
    if (value.length < 1 || sum === 0) {
        callback(new Error('至少要选择1张图片'));
    } else if (sum > 9) {
        callback(new Error('图片数量需小于等于9张'));
    } else if (context.$refs.imageUrls) {
        let errMsg = await context.$refs.imageUrls.method_validImage()
        if (errMsg) {
            callback(new Error(errMsg));
        } else {
            callback();
        }
    } else  {
        callback()
    }
    
}
const validateDetailImageUrls = async (rule, value, callback, context) => {
    let sum = 0;
    let errMsg = await context.$refs.detailImageUrls.method_validImage()
    if (value.length) {
        value.forEach(v => {
            if (v) sum++;
        })
    }
    if (value.length < 1 || sum === 0) {
        callback(new Error('至少要选择1张图片'));
    } else if (sum > 50) {
        callback(new Error('图片不允许超过50张'));
    } else if(errMsg) {
        callback(new Error(errMsg))
    } else {
        callback()
    } 
}
const validateWhiteBaseImageUrl = async (rule, value, callback, context) => {
    let errMsg = await context.$refs.whiteBaseImageUrl.method_validImage()
    if(errMsg) {
        callback(new Error(errMsg))
    } else {
        callback()
    } 
}

const validatePreTime = (rule, value, callback) => {
    let val = (value || []).filter(Boolean)
    let uniqueVal = Array.from(new Set(val))
    if (!val.length) {
        callback(new Error('至少填写一个预售发货时间')) 
    } else if(uniqueVal.length !== val.length) {
        callback(new Error('预售发货时间重复'))
    } else if(val.some(v => v > 15)) {
        callback(new Error('预售发货时间不能超过15天'))
    } else if(val.some(v => v < 3)) {
        callback(new Error('预售发货时间不能小于3天'))
    } else {
        callback()
    }
}

// 若需要vm上下文请用此函数包裹
function contextWrap(fn, context) {
    return (rule, value, callback) => fn(rule, value, callback, context)
}
const validatePic34 = async (rule, value, callback, context) => {
    if(context.$refs.mainImages34){
        let errMsg = await context.$refs.mainImages34.method_validImage()
        if (errMsg) {
            callback(new Error(errMsg));
        } else {
            callback();
        }
    } else {
        callback();
    }
}
const validateSkuPrice = (value, prop) => {
    value = String(value).trim();
    const valueNum = Number(value);
    const idx = value.lastIndexOf('.');
    const mStr = value.slice(idx+1);
    if (value === '') {
        return prop.label + '不能为空值!'
    } else if(valueNum <= 0.01) {
        return prop.label + '必须大于0.01';
    } else if (isNaN(valueNum)) {
        return prop.label + '必须为大于等于0的正数且支持小数点后2位';
    } else if (valueNum <= 0) {
        return prop.label + '必须为大于等于0的正数且支持小数点后2位';
    } else if (idx !== -1 &&  mStr.length > 2) {
        return prop.label + '必须为大于等于0的正数且支持小数点后2位';
    } else {
        return false;
    }
}
const RULES = function(context) {
    return {
        categoryIds: [
            {required: true, message: '请选择类目'},
            {validator: validateCategoryIds}
        ],
        imageUrls: [
            {required: true, message: '至少选择1张照片'},
            {validator: contextWrap(validateImageUrls, context)}
        ],
        whiteBaseImageUrl: [
            {validator: contextWrap(validateWhiteBaseImageUrl, context)}
        ],
        title: [
            {required: true, message: '请输入商品名称'},
            {validator: contextWrap(validateTitle, context)},
        ],
        shortTitle: [
            {validator: contextWrap(validateShortTitle, context)},
        ],
        details: [
            // {required: true, message: '请输入商品描述'},
            {max: 300, message: '长度不能超过300', trigger: 'change'},
        ],
        detailImageUrls: [
            {required: true, message: '至少要选择1张图片'},
            {validator: contextWrap(validateDetailImageUrls, context)},
        ],
        mainImages34:[
            {required: false, message: ''},
            {validator: contextWrap(validatePic34, context), trigger: 'change'},
        ],
        limitCount: [
            {required: true, message: '请输入限购数量'},
        ],
        'sellTimeConfig.presellTime': [
            {required: true, validator: validatePreTime},
        ],
        theDayOfDeliverGoodsTime: [
            {required: true, message: '请输入发货间隔时间'}
        ]
    };
} 

export {
    RULES as default,
    validateSkuPrice
}
